import classNames from "classnames/bind";
import styles from "./Header.module.scss";
import "./Header.scss";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { callFetchAccount, callLogout } from "../../../config/api";
import { Avatar, Dropdown, Space, message } from "antd";
import {
  fetchAccount,
  setLogoutAction,
} from "../../../redux/slice/accountSlide";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import logoImage from "../../../assets/images/happy_learning.jpg";
import SidebarMobile from "../SidebarMobile/SidebarMobile";
import { fetchCategory } from "../../../redux/slice/categorySlice";
import Search from "../../components/Search/Search";
import ManageAccount from "../../../pages/components/ManageAccount";
import NotifyHeader from "./NotifyHeader";
const css = classNames.bind(styles);

function Header() {
  const [user, setUser] = useState<any>();
  const users = useAppSelector((state) => state.account.user);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const info = () => {
    message.warning("Chức năng này đang trong quá trình hoàn thiện");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  let query = `current=1&pageSize=10`;
  // let queryPost = `current=1&pageSize=6&sort=-updatedAt`;
  useEffect(() => {
    dispatch(fetchCategory({ query }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch(fetchAccount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    const res = await callLogout();
    if (res && res.data) {
      dispatch(setLogoutAction({}));
      message.success("Đăng xuất thành công");
      navigate("/login");
    }
  };

  const items = [
    {
      label: (
        <label style={{ cursor: "pointer" }} onClick={showModal}>
          Quản lý tài khoản{" "}
        </label>
      ),
      key: "account",
    },
    {
      label: (
        <label style={{ cursor: "pointer" }} onClick={() => handleLogout()}>
          Đăng xuất
        </label>
      ),
      key: "logout",
    },
  ];

  if (user?.role.name !== "NORMAL_USER") {
    items.unshift({
      label: <Link to="/admin">Trang quản trị</Link>,
      key: "admin",
    });
  }

  const handleNavigate = (item: string) => {
    navigate(item);
  };
  useEffect(() => {
    const handleFetchAccount = async () => {
      const res = await callFetchAccount();
      setUser(res.data?.user);
    };
    handleFetchAccount();
  }, []);
  return (
    <div className={css("wrapper")}>
      <div className={css("container-header")}>
        <div className="wrapper_header_nav">
          <nav className="nav-sidebar">
            <ul className="container">
              <li className="menu">
                <img width={48} height={40} src={logoImage} alt="logo" />
              </li>
              <li className="menu">
                <a href="##">Nỗ lực tốt hơn 1% mỗi ngày</a>
              </li>
            </ul>
          </nav>
          {/* <Search /> */}
          <SidebarMobile />
        </div>

        <Search />
        <div className={css("container-menu-left")}>
          {/* <SearchMobile /> */}

          {user && user._id ? (
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <button className={css("my-course")} onClick={info}>
                Khóa học của tôi
              </button>
              <NotifyHeader />
              <Dropdown menu={{ items }} trigger={["click"]}>
                <a href="##" onClick={(e) => e.preventDefault()}>
                  <Space>
                    <Avatar
                      style={{
                        width: 35,
                        height: 35,
                        border: "1px solid #ccc",
                      }}
                      src={users?.avatar}
                    />
                    {user?.fullName}
                    {/* <DownOutlined /> */}
                  </Space>
                </a>
              </Dropdown>
            </div>
          ) : (
            <div>
              <button
                onClick={() => handleNavigate("/login")}
                className={css("btn-login")}>
                Đăng nhập
              </button>
              <button
                onClick={() => handleNavigate("/register")}
                className={css("btn-register")}>
                Đăng ký
              </button>
            </div>
          )}
        </div>
      </div>
      <ManageAccount isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </div>
  );
}

export default Header;
